<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <!-- <b-navbar-brand center>Sales Execution Reports</b-navbar-brand> -->
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button
                class="pull-right"
                v-if="consoBooking.length > 0"
                @click="getReports"
                size="sm"
                variant="warning"
                >Export as Excel
              </b-button>
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>

        <div>
          <!-- Using modifiers -->
          <!-- <b-button
                variant="outline-dark"
                :class="visible ? null : 'collapsed'"
                :aria-expanded="visible ? 'true' : 'false'"
                aria-controls="collapse-4"
                @click="visible = !visible"
          >Filters</b-button>-->
          <b-collapse v-model="visible" id="collapse-2">
            <b-card>
              <md-layout md-gutter class="align-items-center">
                <md-layout md-flex="30" md-flex-small="100">
                  <model-list-select
                    :list="clientMaster"
                    id="clientNamenew"
                    v-model="clientIdFilter"
                    option-value="clientId"
                    option-text="clientName"
                    placeholder="Select  Client Name"
                  ></model-list-select>
                </md-layout>
                <!-- <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="20" md-flex-small="100">
                      <model-list-select
                        :list="jTypeList"
                        v-model="jobTypeFilter"
                        option-value="jTypeVal"
                        option-text="jTypeText"
                        placeholder="Select Job Type "
                      ></model-list-select>
                </md-layout>-->
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30" md-flex-small="100">
                  <model-list-select
                    :list="shipmentTypeList"
                    v-model="shipmentTypeFilter"
                    option-value="shipmentTypeVal"
                    option-text="shipmentTypeText"
                    placeholder="Select Sea / Air"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30" md-flex-small="100">
                  <model-list-select
                    :list="flTypeList"
                    v-model="fclLclFilter"
                    option-value="flVal"
                    option-text="flText"
                    placeholder="Select FCL / LCL"
                  ></model-list-select>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="gutr align-items-center">
                <md-layout md-flex="30" md-flex-small="100">
                  <model-list-select
                    :list="transportTypeName"
                    v-model="transportTypeFilter"
                    option-value="transportTypeVal"
                    option-text="transportTypeText"
                    placeholder="Select Export / Import"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30" md-flex-small="100">
                  <model-list-select
                    :list="containerList"
                    v-model="containerFilter"
                    option-value="containerTypeId"
                    option-text="containerType"
                    placeholder="Select Container Type"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30" md-flex-small="100">
                  <model-list-select
                    :list="shippingList"
                    v-model="shippingFilter"
                    option-value="shippingId"
                    option-text="shippingLine"
                    placeholder="Select Shipping Line"
                  ></model-list-select>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="30" md-flex-small="100">
                  <model-list-select
                    :list="invoiceStatusList"
                    v-model="statusFilter"
                    option-value="inv"
                    option-text="int"
                    placeholder="Select Status"
                  ></model-list-select>
                </md-layout>

                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30" md-flex-small="100">
                  <date-range-picker
                    :opens="openRight"
                    :always-show-calendars="showCal"
                    v-model="dateRange"
                    :startDate="startDate"
                    :endDate="endDate"
                    :locale-data="locale"
                  >
                    <!--Optional scope for the input displaying the dates -->
                    <!-- <div slot="input" slot-scope="picker">{{ picker.startDate }} - {{ picker.endDate }}</div> -->
                  </date-range-picker>
                  <!-- <date-picker
        v-model="dateRange"
        type="datetime"
        range
        placeholder="Select datetime range"
      ></date-picker> -->
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30" md-flex-small="100">
                  <model-list-select
                    :list="finalAllPlaceDataLP"
                    v-model="branchfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Branch"
                  ></model-list-select>
                </md-layout>
              </md-layout>
              <b-row class="mt-4 justify-content-center">
                <div>
                  <b-button
                    style="margin-right: 0.5rem"
                    size="sm"
                    @click="filterSearch"
                    variant="outline-primary"
                    >Search</b-button
                  >
                  <b-button
                    style="margin-right: 0.5rem"
                    size="sm"
                    @click="clearFilter"
                    variant="outline-info"
                    >clear</b-button
                  >
                </div>
              </b-row>
            </b-card>
          </b-collapse>
        </div>
        <div class="mt-3">
          <div>
            <b-button
              variant="outline-dark"
              :class="visible ? null : 'collapsed'"
              :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4"
              @click="visible = !visible"
              >Filters</b-button
            >
            <h5 class="text-muted pull-right">
              <small>{{ totalRows }} Entries</small>
            </h5>
          </div>

          <div class="table-responsive tableMain mt-3">
            <b-table
              show-empty
              stacked="md"
              :items="consoBooking"
              :fields="fields"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
            >
              <template slot="jobType" slot-scope="row0">
                <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
              </template>
              <template slot="mainSalesSeries" slot-scope="row1">
                <md-icon>{{
                  row1.item.shipmentType == "1"
                    ? "directions_boat"
                    : "flight_takeoff"
                }}</md-icon>
                <b>{{ row1.item.mainSalesSeries }}</b>
                <br />
                <span
                  >Assignment Type : {{ row1.item.jobType }} ({{
                    row1.item.shipmentType == "1" ? "Sea" : "Air"
                  }}
                  {{ row1.item.transportType }}) -
                  {{ row1.item.containerInfo }}</span
                >
                <br />
                <span
                  >Assignment Date : {{ row1.item.loginTime | moment }}</span
                >
                <br />
                <span>Raised From : {{ row1.item.baseLoc }}</span>
              </template>
              <template slot="TPTClient" slot-scope="row11">
                <b
                  v-if="
                    row11.item.clientType == '3' &&
                    row11.item.transportType == 'Export'
                  "
                >
                  Client Name : {{ row11.item.exporter }}
                  <br />
                </b>
                <b v-if="row11.item.clientType == '3'">
                  Overseas Agent : {{ row11.item.TPTClient }}
                  <br />
                </b>
                <b v-if="row11.item.clientType != '3'">
                  {{ row11.item.TPTClient }}
                  <br />
                </b>
              </template>
              <template slot="mainEnquirySeries" slot-scope="row2">
                <span>{{ row2.item.mainEnquirySeries }}</span>
                <br />
                <span
                  >Enquiry Type : {{ row2.item.EnqJob }} ({{
                    row2.item.shipmentType == "1" ? "Sea" : "Air"
                  }}
                  {{ row2.item.transportType }})</span
                >
                <br />
                <span>Enquiry Date : {{ row2.item.enqDate | moment }}</span>
              </template>
              <template slot="POR" slot-scope="row7">
                <div v-if="row7.item.shipmentType == '1'">
                  <span
                    >Container Type :
                    {{ row7.item.multipleContainerType }}</span
                  >
                  <br />
                  <span>No of Containers : {{ row7.item.multiConNo }}</span>
                  <br />
                  <span>Shipping Line : {{ row7.item.shippingLine }}</span>
                  <br />
                  <span>Pickup : {{ row7.item.pickup }}</span>
                  <br />
                  <span>Stuffing : {{ row7.item.stuffingLoc }}</span>
                  <br />
                  <span>Handover : {{ row7.item.handover }}</span>
                  <br />
                  <span>Place of Receipt : {{ row7.item.POR }}</span>
                  <br />
                  <div v-if="row7.item.jobType.split(',').includes('FF')">
                    <span>Load Port : {{ row7.item.LP }}</span>
                    <br />
                    <span>Port of Discharge : {{ row7.item.POD }}</span>
                    <br />
                    <span
                      >Final Place of Delivery :
                      {{ row7.item.finalPlace }}</span
                    >
                  </div>
                </div>
                <div v-else>
                  <span>
                    Departure Airport : {{ row7.item.AirDept }}
                    <br />
                  </span>
                  <span>
                    Destination Airport : {{ row7.item.airDesti }}
                    <br />
                  </span>
                  <span>
                    No.of Packages : {{ row7.item.noOfPkg }}
                    <br />
                  </span>
                  <span>
                    Cargo Received At :
                    {{
                      row7.item.cargoReceived == "1" ? "Airport" : "Warehouse"
                    }}
                    <br />
                  </span>
                </div>
              </template>

              <!-- <template slot="allModuleId" slot-scope="row9">
                <md-button
                  :disabled="row9.item.asignDeleted=='1'"
                  @click="viewExportFCLConPage(row9.item.allModuleId)"
                >
                  <a class="fa fa-pencil-square-o"></a>
                </md-button>
              </template>-->
              <template slot="deleteRequest" slot-scope="row10">
                <td>
                  <b
                    style="color: red"
                    v-if="row10.item.deleteRequest == '0'"
                    class="showMoreData"
                    @click="
                      execActions(
                        row10.item.allModuleId,
                        '1',
                        row10.item.mainSalesSeries
                      )
                    "
                    >Request To Delete Assignment</b
                  >
                  <br v-if="row10.item.deleteRequest == '0'" />
                  <b
                    style="color: red"
                    v-if="
                      row10.item.deleteRequest == '1' &&
                      row10.item.ApproveRejectDelReq == '0' &&
                      ($sessionsStorage.get('designation') == 'manager' ||
                        $sessionsStorage.get('designation') == 'employee')
                    "
                    >Sent For Delete Approval</b
                  >

                  <br
                    v-if="
                      row10.item.deleteRequest == '1' &&
                      row10.item.ApproveRejectDelReq == '0' &&
                      ($sessionsStorage.get('designation') == 'manager' ||
                        $sessionsStorage.get('designation') == 'employee')
                    "
                  />
                  <b
                    @click="
                      execActions(
                        row10.item.allModuleId,
                        '2',
                        row10.item.mainSalesSeries
                      )
                    "
                    style="color: red"
                    v-if="
                      row10.item.deleteRequest == '1' &&
                      row10.item.ApproveRejectDelReq != '2' &&
                      ($sessionsStorage.get('designation') == 'Admin' ||
                        $sessionsStorage.get('designation') == 'HOD')
                    "
                    class="showMoreData"
                    >Approve Delete Request /</b
                  >
                  <b
                    @click="
                      execActions(
                        row10.item.allModuleId,
                        '3',
                        row10.item.mainSalesSeries
                      )
                    "
                    style="color: red"
                    v-if="
                      row10.item.deleteRequest == '1' &&
                      row10.item.ApproveRejectDelReq != '2'
                    "
                    class="showMoreData"
                    >Reject Delete Request</b
                  >
                  <br
                    v-if="
                      row10.item.deleteRequest == '0' &&
                      row10.item.ApproveRejectDelReq != '2'
                    "
                  />
                  <b
                    @click="
                      execActions(
                        row10.item.allModuleId,
                        '4',
                        row10.item.mainSalesSeries
                      )
                    "
                    style="color: red"
                    v-if="
                      row10.item.ApproveRejectDelReq == '2' &&
                      row10.item.asignDeleted != '1'
                    "
                    class="showMoreData"
                    >Delete Assignment</b
                  >
                  <b style="color: red" v-if="row10.item.asignDeleted == '1'"
                    >Assignment Deleted</b
                  >
                </td>
              </template>
            </b-table>
          </div>
        </div>

        <div>
          <b-pagination
            align="center"
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalRows"
            @change="onPageChange($event)"
          ></b-pagination>
        </div>
      </b-card-text>
    </b-card>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAction"
      ref="addPopMail"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAction"
      ref="addPopApprove"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAction"
      ref="addPopReject"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAction"
      ref="addPopDelete"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import DateRangePicker from "vue2-daterange-picker";
import {
  globalPermissionStatus,
  GlobalGetLocation,
} from "../../../helper/collection";

export default {
  beforeMount() {
    this.viewFFExportFCL("0", "1", "1");
  },

  data() {
    return {
      finalAllPlaceDataPOR: [],
      finalAllPlaceDataPOD: [],
      finalAllPlaceDataLP: [],
      commodityList: [],
      airlineList: [],
      containerList: [],
      shippingList: [],
      clientTypeFilter: "",
      clientIdFilter: "",
      transportTypeFilter: "",
      shipmentTypeFilter: "",
      jobTypeFilter: "",
      enqOrExuFilter: "",
      PORfilter: "",
      PODfilter: "",
      branchfilter: "",
      commodityFilter: "",
      shippingFilter: "",
      statusFilter: "",
      enquiryFilter: "",
      fclLclFilter: "",
      airlineFilter: "",
      containerFilter: "",
      jTypeList: [
        {
          jTypeVal: "TPT",
          jTypeText: "TPT",
        },
        {
          jTypeVal: "FF",
          jTypeText: "FF",
        },
        {
          jTypeVal: "CC",
          jTypeText: "CC",
        },
      ],
      transportTypeName: [
        {
          transportTypeVal: "Export",
          transportTypeText: "Export",
        },
        {
          transportTypeVal: "Import",
          transportTypeText: "Import",
        },
      ],
      shipmentTypeList: [
        {
          shipmentTypeVal: "1",
          shipmentTypeText: "Sea",
        },
        {
          shipmentTypeVal: "2",
          shipmentTypeText: "Air",
        },
      ],
      flTypeList: [
        {
          flVal: "fcl",
          flText: "FCL",
        },
        {
          flVal: "lcl",
          flText: "LCL",
        },
      ],

      reload: true,
      clientMaster: [],
      totalRows: 1,
      currentPage: 2,
      perPage: 10,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      fields: [
        {
          key: "jobType",
          mainkey: "jobType",
          label: "Sr No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "mainSalesSeries",
          mainkey: "mainSalesSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "TPTClient",
          mainkey: "clientName",
          label: "Client / Shipper Name",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "mainEnquirySeries",
          mainkey: "mainEnquirySeries",
          label: "Enquiry No.",
          sortable: true,
          sortDirection: "ASC",
          table: "Z.",
        },
        {
          key: "POR",
          mainkey: "POR",
          label: "Assignment Details",
          sortable: true,
          sortDirection: "ASC",
          //  table: "B."
        },
        // {
        //   key: "isAllActive",
        //   mainkey: "isAllActive",
        //   label: "Split / Merge Details",
        //   sortable: true,
        //   sortDirection: "ASC"
        //   //  table: "B."
        // },
        // {
        //   key: "deleteRequest",
        //   mainkey: "deleteRequest",
        //   label: "Action",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   class: "text-center"
        //   //  table: "B."
        // }

        // {
        //   key: "allModuleId",
        //   mainkey: "allModuleId",
        //   label: "View",
        //   sortable: true,
        //   sortDirection: "ASC"
        // }
      ],
      dateSearch: {
        fromDate: "",
        toDate: "",
      },
      eventId: "",
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      openRight: "right",
      showCal: false,
      showDash: false,
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      mailallModuleId: "",
      mailExecSeries: "",
      isLoading: false,
      visible: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      invoiceStatusList: [
        {
          inv: "0",
          int: "In-Complete",
        },
        {
          inv: "1",
          int: "Completed",
        },
      ],

      consoBooking: [],
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
  },

  computed: {},

  methods: {
    getReports() {
      let view_Assignment = {
        excelId: "MD_EXECUTION_BILLING",
        // dateRange: this.dateRange,
        clientId: this.clientIdFilter,
        shipmentType: this.shipmentTypeFilter,
        transportType: this.transportTypeFilter,

        shippingFilter: this.shippingFilter,
        statusFilter: this.statusFilter,
        branchfilter: this.branchfilter,

        fclLclFilter: this.fclLclFilter,
        airlineFilter: this.airlineFilter,
        containerFilter: this.containerFilter,
        dateRange: this.dateRange,
      };
      console.log(view_Assignment);

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_EmpDashboard/mainDashBoardreportsExcel.php`,
        data: JSON.stringify(view_Assignment),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.excelName != undefined) {
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` +
                data.excelName;
            }
            //       let abc= `${docURL}/Pridel_Reports/`+data.excelName

            // console.log(abc)
          }
        })
        .catch((error) => {});
    },
    filterSearch() {
      this.reload = false;
      this.viewFFExportFCL("0", "1");
    },
    clearFilter() {
      this.shippingFilter = "";
      this.statusFilter = "";
      this.enquiryFilter = "";
      this.fclLclFilter = "";
      this.airlineFilter = "";
      this.containerFilter = "";
      this.clientIdFilter = "";
      this.transportTypeFilter = "";
      this.shipmentTypeFilter = "";

      this.PORfilter = "";
      this.PODfilter = "";
      this.branchfilter = "";
      this.viewFFExportFCL("0", "1");
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };

      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    proceedBilling(item) {
      this.$sessionsStorage.set("editSalesExId", item);
      this.$router.push({
        path: "/allModuleForm/billing/" + item,
      });
    },
    onPageChange: function (event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.viewFFExportFCL(CURRENT, "2", event);

      // let totalRows = 1064 / this.perPage;
      // if(this.totalRow )
    },
    execActions(allModuleId, id, series) {
      this.mailallModuleId = allModuleId;
      this.eventId = id;
      this.mailExecSeries = series;

      if (id == "1") {
        this.alert.content = "Send Mail For Approval?";
        this.$refs["addPopMail"].open();
      }
      if (id == "2") {
        this.alert.content = "Are you sure you want to Approve?";
        this.$refs["addPopApprove"].open();
      }
      if (id == "3") {
        this.alert.content = "Are you sure you want to Reject?";
        this.$refs["addPopReject"].open();
      }
      if (id == "4") {
        this.alert.content = "Are you sure you want to delete this Execution ?";
        this.$refs["addPopDelete"].open();
      }
    },

    onCloseAction(type) {
      if (type != "cancel") {
        this.isLoading = true;
        let payload = {
          allModuleId: this.mailallModuleId,
          salesExecutionNo: this.mailExecSeries,
          eventId: this.eventId,
        };
        console.log(payload);

        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/salesDeleteActions.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.viewFFExportFCL("0", "1", "1");
              this.isLoading = false;
            }
          })
          .catch((error) => {});
      }
    },
    // goToMain() {
    //   this.$sessionsStorage.set("editallModuleId", "");
    //   this.$router.push({
    //     path: "/allModuleForm/allModuleForm"
    //   });
    // },
    JqueryFun() {
      return $(function () {
        return $("#conBooking").DataTable();
      });
    },

    viewExportFCLConPage(AM) {
      this.$sessionsStorage.set("editSalesExId", AM);

      this.$router.push({
        path: "/mainEnquiry/salesExecutionAll",
      });
    },
    viewFFExportFCL(CURRENT, SEARCH, pageNumber) {
      this.consoBooking = [];
      this.isLoading = true;
      let payload = {
        clientId: this.clientIdFilter,
        shipmentType: this.shipmentTypeFilter,
        transportType: this.transportTypeFilter,
        PORfilter: this.PORfilter,
        PODfilter: this.PODfilter,
        branchfilter: this.branchfilter,
        shippingFilter: this.shippingFilter,
        statusFilter: this.statusFilter,
        enquiryFilter: this.enquiryFilter,
        fclLclFilter: this.fclLclFilter,
        airlineFilter: this.airlineFilter,
        containerFilter: this.containerFilter,
        fields: this.fields,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        assignmentNo: "assignmentNo",
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
      };
      console.log(payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_EmpDashboard/getExecBillingList.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            if (SEARCH != "2") {
              this.currentPage = 1;
              this.totalRows = data.totalData;
            } else {
              this.currentPage = pageNumber;
            }
            if (data.assignmentData.length > 0) {
              this.consoBooking = data.assignmentData;
            } else {
              this.consoBooking = [];
            }
            this.isLoading = false;
            if (this.reload == true) {
              if (data.LocationDetailsFinal.length > 0) {
                this.finalAllPlaceDataPOR = data.LocationDetailsFinal;
                this.finalAllPlaceDataPOD = data.LocationDetailsFinal;
                this.finalAllPlaceDataLP = data.LocationDetailsFinal;
              }
              if (data.shippingList.length > 0) {
                this.shippingList = data.shippingList;
              }
              if (data.airlineList.length > 0) {
                this.airlineList = data.airlineList;
              }
              if (data.containerList.length > 0) {
                this.containerList = data.containerList;
              }
              if (data.clientMaster.length > 0) {
                this.clientMaster = data.clientMaster;
              }
            }
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style>
.card {
  box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
  border-radius: 0.428rem;
}
@media (max-width: 944px) {
  .md-flex-small-100 {
    margin-top: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// salesReports.vue?36aa1aca